import { type RefObject, useMemo, useRef, useState } from "react";

import { translate } from "app/filters/i18nFilter";
import type { CrmEnrichmentJobTabName } from "app/pages/sales-intelligence/modules/crm-enrichment/types/types";
import type { StickyTabItemConfig } from "app/pages/sales-intelligence/sub-modules/account-overview/shared/components/StickyTabs/types";

const useJobStickyTabs = () => {
    const typeRef = useRef<HTMLDivElement>(null);
    const settingsRef = useRef<HTMLDivElement>(null);
    const filtersRef = useRef<HTMLDivElement>(null);
    const fieldsMappingRef = useRef<HTMLDivElement>(null);

    const [activeTab, setActiveTab] = useState<CrmEnrichmentJobTabName>("type");
    const [isScrolling, setIsScrolling] = useState(false);

    const onIntersection = (tabName: CrmEnrichmentJobTabName) => {
        if (isScrolling) {
            return;
        }

        setActiveTab(tabName);
    };

    const onTabClick = (tabName: CrmEnrichmentJobTabName) => {
        setActiveTab(tabName);
        setIsScrolling(true);

        setTimeout(() => {
            setIsScrolling(false);
        }, 1000);
    };

    const tabsConfig: StickyTabItemConfig[] = useMemo(
        () => [
            {
                title: translate("si.crm-enrichment.job-wizard.legend.type"),
                id: "type",
            },
            {
                title: translate("si.crm-enrichment.job-wizard.legend.settings"),
                id: "settings",
            },
            {
                title: translate("si.crm-enrichment.job-wizard.legend.filters"),
                id: "filters",
            },
            {
                title: translate("si.crm-enrichment.job-wizard.legend.fields-mapping"),
                id: "fields-mapping",
            },
        ],
        [],
    );
    const tabsRefs: Record<CrmEnrichmentJobTabName, RefObject<HTMLDivElement | null>> = useMemo(
        () => ({
            type: typeRef,
            settings: settingsRef,
            filters: filtersRef,
            "fields-mapping": fieldsMappingRef,
        }),
        [],
    );

    return {
        activeTab,
        tabsConfig,
        tabsRefs,
        onTabClick,
        onIntersection,
    };
};

export default useJobStickyTabs;
